/* eslint-disable react/button-has-type */
import React from 'react';
import { useNavigate } from 'react-router-dom';

import Heading from 'Components/Heading/Heading';
import Summary from 'Components/Summary/Summary';
import CoreValues from '../../Assets/elvotaimages/core_values.png';
import MeetTheTeam from '../../Assets/elvotaimages/meet_the_tean.png';

export default function AboutUs() {
  const navigate = useNavigate();
  const summaryContent = [
    'We are a team driven by innovation, collaboration, and a passion for creating meaningful solutions. Our mission is to deliver high-quality work while building lasting relationships with our clients and partners. Every project we take on is guided by creativity, dedication, and a commitment to excellence.',
  ];
  return (
    <div>
      <div className="main-container about-us-container">
        <div>
          <Heading content="About us" />
          <Summary paragraph={summaryContent} />
        </div>
        <div className="mt-10 xl:mt-0 xl:py-10">
          <div className="grid grid-cols-12 gap-5 lg:gap-10">
            <div className="col-span-12 sm:col-span-6">
              <div className=" relative text-black hover:text-white bg-class-for-test p-4 sm:p-0 h-auto lg:h-[492px] lg:hover:h-[512px] sm:pt-[21px] sm:pb-[47px]  sm:px-[25px]  rounded-[20px] ">
                <div className="bg-animated" />
                <div className="z-10 relative">
                  <img
                    src={MeetTheTeam}
                    className="w-full h-auto cursor-pointer"
                    alt=""
                    onClick={() => navigate('/about-us#team')}
                  />

                  <h1 className="f-f-b-ex text-[18px] sm:text-xl  mt-2 ">
                    Meet the Team
                  </h1>
                  <p className="f-f-r text-lg  mt-2 pb-8 sm:pb-0 ">
                    Behind every great project is a group of passionate people.
                    Our team brings together diverse skills, perspectives, and
                    experiences to turn ideas into reality.
                  </p>
                  <div className="col-span-12">
                    <button
                      className="w-[116px] h-[41px] bg-green hover:bg-black-light hover:text-white transition-colors duration-500 rounded-[20px] f-f-sm text-sm text-black-light mt-5 footer-font"
                      onClick={() => navigate('/about-us#team')}
                    >
                      More Info
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6">
              <div className=" relative text-black hover:text-white bg-class-for-test p-4 sm:p-0 h-auto lg:h-[492px] lg:hover:h-[512px] sm:pt-[21px] sm:pb-[47px]  sm:px-[25px]  rounded-[20px] ">
                <div className="bg-animated" />
                <div className="z-10 relative">
                  <img
                    src={CoreValues}
                    className="w-full h-auto cursor-pointer"
                    alt=""
                    onClick={() => navigate('/about-us#vision-core-values')}
                  />

                  <h1 className="f-f-b-ex text-[18px] sm:text-xl  mt-2 ">
                    Vision & Core Values
                  </h1>
                  <p className="f-f-r text-lg  mt-2 pb-8 sm:pb-0 ">
                    Our vision shapes where we are going, and our core values
                    guide how we get there. From integrity and innovation to
                    collaboration and impact, these principles define everything
                    we do.
                  </p>
                  <div className="col-span-12">
                    <button
                      className="w-[116px] h-[41px] bg-green hover:bg-black-light hover:text-white transition-colors duration-500 rounded-[20px] f-f-sm text-sm text-black-light mt-5 footer-font"
                      onClick={() => navigate('/about-us#vision-core-values')}
                    >
                      More Info
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
